import { ITheme } from './theme.interface';

export const flowTheme: ITheme = {
  name: 'flow',
  properties: {
    // ODS Theme
    '--primary-brand-bg': '#e3f2fd',
    '--primary-brand-black-light': '#d5d5dd',
    '--primary-brand-black-low-light': '#b6b6b9',
    '--primary-brand-black-main': '#0f0f19',
    '--primary-brand-black-medium-light': '#6e6e72',
    '--primary-brand-black-medium': '#3a3a42',
    '--primary-brand-black-silver': '#ebebf0',
    '--primary-brand-bright': '#0e6a8c',
    '--primary-brand-light': '#99ccdf',
    '--primary-brand-main': '#00445d',
    '--primary-brand-medium': '#0080af',
    '--primary-brand-white-main': '#f5f3f5',
    '--primary-brand-white-white': '#ffffff',
    '--primary-brand-zebra': '#f9fcff',
    '--semantic-error-low': '#efd5d6',
    '--semantic-error-medium': '#ad2f33',
    '--semantic-error-strong': '#9d2b2e',
    '--semantic-success-low': '#dff0de',
    '--semantic-success-medium': '#5fb25c',
    '--semantic-success-strong': '#41833e',
    '--semantic-warning-low': '#fef1d9',
    '--semantic-warning-medium': '#fcb83f',
    '--semantic-warning-strong': '#e3a639',
    '--supplementary-button-surface-primary-default': '#d9d9d9',
    '--supplementary-button-text-primary-default': '#ffffff',
    '--supplementary-button-text-secondary-tertiary-default': '#00445d',
    '--supplementary-left-nav-text-primary-default': '#3a3a42',
    '--supplementary-left-nav-text-primary-selected': '#ffffff',
    '--supplementary-link-default': '#1667ff',
    '--supplementary-link-visited': '#6a1fde',
    //ODS gradients
    '--gradient-dp-world': 'linear-gradient(90deg, #00445d 0%, #0080af 100%)',
    '--gradient-dp-world-black': 'linear-gradient(90deg, #0f0f19 0.02%, #1c1825 99.96%)',
    '--gradient-dp-world-white': 'linear-gradient(90deg, #d5d5dd 0.02%, #f5f3f5 99.96%)',
    '--gradient-dp-world-overlay': 'linear-gradient(92deg, #ebebf0 2.63%, rgba(255, 255, 255, 0.42) 54.19%, rgba(255, 255, 255, 0) 98.73%)',
  },
};
